module.exports = __webpack_public_path__ + "img/f-min.d13ca618.jpg";